import { safeGoodsBackCountUtil } from 'pangu-core'

export default safeGoodsBackCountUtil
